/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  SetDefaultPaymentMethod: (params: vp.SetDefaultPaymentMethodRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostSetDefaultPaymentMethod: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSetDefaultPaymentMethod, setShouldSetDefaultPaymentMethod] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.SetDefaultPaymentMethodRequest>({
    PortalUser: '',
    PaymentMethod: 'vopay',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldSetDefaultPaymentMethod) return () => {};

    const PostDeleteClientBankAccount = async () => {
      setDataFetchingInfo(true, 'Setting default account', 'fullScreen');
      const res = await api.postSetDefaultPaymentMethod(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSetDefaultPaymentMethod) void PostDeleteClientBankAccount();
    setShouldSetDefaultPaymentMethod(false);
    return () => {
      source.cancel();
    };
  }, [shouldSetDefaultPaymentMethod]);

  return [
    response,
    (_params: vp.SetDefaultPaymentMethodRequest) => {
      setParams(_params);
      setShouldSetDefaultPaymentMethod(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldSetDefaultPaymentMethod(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostSetDefaultPaymentMethod);
